var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"mt-10 mb-0 ml-10 mr-10 grey--text",staticStyle:{"margin-left":"10px"}},[_vm._v("Your saved movies")]),_c('saved-movies')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }